import React from 'react'
import PublicEventoperator from "../eventoperator/PublicEventoperator";
import PublicEventoperatorNeu from "./PublicEventoperatorNeu";
import AnsichtWechselKnopf from "../tournamentneu/AnsichtWechselKnopf";
import {useOeffentlicheAnsicht} from "../../../../util/oeffentlicheAnsichtZugriff";

/**
 * Entscheidet, ob die alte oder die neue Veranstalterseite angezeigt wird.
 * Der Wechsel über den Knopf oben rechts gilt dauerhaft und für alle öffentlichen Seiten.
 */
export default function PublicEventoperatorAnsicht(props) {

    const ansicht = useOeffentlicheAnsicht();

    return <AnsichtWechselKnopf neueAnsicht={ansicht.neueAnsicht} onWechseln={ansicht.wechseln}>
        {ansicht.neueAnsicht ? <PublicEventoperatorNeu {...props}/> : <PublicEventoperator {...props}/>}
    </AnsichtWechselKnopf>
}
